"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9201],{

/***/ 9129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
;// CONCATENATED MODULE: ./sites/au/states.ts
var auStates = [
    {
        name: "New South Wales",
        value: "NSW"
    },
    {
        name: "Victoria",
        value: "VIC"
    },
    {
        name: "Queensland",
        value: "QLD"
    },
    {
        name: "Western Australia",
        value: "WA"
    },
    {
        name: "South Australia",
        value: "SA"
    },
    {
        name: "Tasmania",
        value: "TAS"
    },
    {
        name: "Australian Capital Territory",
        value: "ACT"
    },
    {
        name: "Northern Territory",
        value: "NT"
    }, 
];

;// CONCATENATED MODULE: ./sites/au/validations.ts
var auPostalCodeValidation = "^\\d{4}$";

// EXTERNAL MODULE: ./sites/common/fields.ts
var fields = __webpack_require__(50384);
;// CONCATENATED MODULE: ./sites/au/fields.ts




var AUFieldProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields/* commonFieldsProps */.I), {
    phone: {
        fieldType: "input",
        validations: [
            "phoneNumber"
        ],
        maxLength: 15
    },
    countryCode: {
        fieldType: "dropdown",
        validations: [],
        disabled: true,
        options: [
            {
                label: "Australia",
                value: "AU"
            }
        ]
    },
    postalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 4,
        validations: [
            "postalCode"
        ]
    },
    billingPostalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 4,
        validations: [
            "postalCode"
        ]
    },
    firstName: {
        fieldType: "input",
        validations: [
            "name"
        ],
        maxLength: 15
    },
    lastName: {
        fieldType: "input",
        validations: [
            "name"
        ],
        maxLength: 15
    },
    companyName: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    address2: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    stateCode: {
        fieldType: "dropdown",
        options: auStates.map(function(state) {
            return {
                value: state.value,
                label: state.name
            };
        })
    },
    address1: {
        fieldType: "google-address-look-up",
        mapAddressLookupResultsToFormValues: [
            {
                resultKey: "stateCode",
                formKey: "stateCode"
            },
            {
                resultKey: "address1",
                formKey: "address1"
            },
            {
                resultKey: "city",
                formKey: "city"
            },
            {
                resultKey: "postalCode",
                formKey: "postalCode"
            }, 
        ],
        validateOnAddressLookupSelect: false,
        submitOnUpdate: false,
        validations: [
            "addressLine1"
        ]
    },
    city: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/au/forms.ts




var addressForm = [
    [
        {
            name: "firstName",
            type: "input",
            required: true
        },
        {
            name: "lastName",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "companyName",
            type: "input"
        }
    ],
    [
        {
            name: "address2",
            type: "input"
        }
    ],
    [
        {
            name: "address1",
            type: "google-address-look-up",
            required: true
        }, 
    ],
    [
        {
            name: "city",
            type: "input",
            required: true
        },
        {
            name: "postalCode",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "stateCode",
            type: "dropdown",
            required: true
        },
        {
            name: "countryCode",
            type: "dropdown"
        }, 
    ], 
];
var AUForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    accountAddress: [
        [
            {
                name: "title",
                type: "input",
                required: true
            }
        ], 
    ].concat((0,_to_consumable_array/* default */.Z)(addressForm), [
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }
        ],
        [
            {
                name: "preferred",
                type: "checkbox"
            }
        ], 
    ]),
    checkoutAddress: (0,_to_consumable_array/* default */.Z)(addressForm),
    checkoutContactInfo: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }, 
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ], 
    ],
    checkoutContactInfoNoSubscription: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }, 
        ], 
    ],
    orderLookUpReturns: [
        [
            {
                name: "orderNo",
                type: "input",
                required: true
            }, 
        ],
        [
            {
                name: "orderEmail",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "billingPostalCode",
                type: "input",
                required: true
            }, 
        ],
        [
            {
                name: "returnsOrderExplainerModal",
                type: "text-to-modal",
                required: true
            }, 
        ],
        [
            {
                name: "submitButton",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ]
});

;// CONCATENATED MODULE: ./sites/au/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// TODO: delete this region config and all related tests, we don't give support to this region website
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files









var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    addressCountries: [
        {
            label: "Australia",
            value: constants/* SUPPORTED_COUNTRY.AU */.bM.AU
        }
    ],
    addressFormat: [
        [
            "firstName",
            "lastName"
        ],
        [
            "address1"
        ],
        [
            "address2"
        ],
        [
            "city"
        ],
        [
            "stateCode",
            "postalCode"
        ],
        [
            "countryCode"
        ], 
    ],
    addressFormatOneLiner: "@{firstName} @{lastName} - @{address1} @{address2} @{city}, @{postalCode} @{stateCode} @{countryCode}",
    addressSearch: {
        billing: [
            "AU"
        ],
        shipping: [
            "AU"
        ]
    },
    addressStates: {
        AU: auStates
    },
    analytics: {
        releaseVersion: "Australia | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [
        "visa",
        "masterCard",
        "amex",
        "discover"
    ],
    badgeIdsExcludedBySaleStatus: [],
    bloomreach: {
        objectName: "br_data",
        viewId: "au"
    },
    charactersNeededToSubmitSearch: 1,
    countryCode: "au",
    countryName: "Australia",
    currency: {
        code: "AUD",
        decimalsToDisplay: 2,
        symbol: "$"
    },
    defaultPaymentMethod: constants/* PaymentMethod.SCHEME */.XL.SCHEME,
    fieldProps: (0,_object_spread/* default */.Z)({}, AUFieldProps),
    flag: "\uD83C\uDDE6\uD83C\uDDFA",
    forms: (0,_object_spread/* default */.Z)({}, AUForms),
    legal: {
        privacyPolicy: "https://au.puma.com/au/en/privacy-policy/PRIVACY_POLICY.html",
        termsAndConditions: "https://au.puma.com/au/en/terms-of-purchase/TERMS_OF_PURCHASE.html"
    },
    liveChat: {
        provider: "zendesk",
        script: "https://static.zdassets.com/ekr/snippet.js?key=ce75f8f8-3d45-45dc-883d-39d7b9044ec1"
    },
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.DAILY */.ho.DAILY,
    maxCountRecordKeeper: 0,
    maximumApplicableCards: 1,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "profileComponent",
                "passwordComponent",
                "preferencesComponent",
                "ambassadorComponent",
                "storeCreditsComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "addressBookComponent",
                "orderHistoryComponent"
            ],
            name: "rightColumn"
        }, 
    ],
    newsletter: {
        contactSources: {
            checkOut: "5",
            footer: "1",
            signUp: "6"
        },
        fields: {
            gender: {
                required: true,
                values: [
                    "male",
                    "female",
                    "noAnswer"
                ]
            }
        }
    },
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByEmailPostcode */.G.SearchOrderByEmailPostcode,
    orderedPaymentPartners: [
        "visa",
        "master",
        "maestro",
        "payPal",
        "klarna",
        "zip",
        "applePay",
        "googlePay",
        "weChatPay",
        "alipay", 
    ],
    paymentMethodsMixedWithGiftCard: [
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.AFTERPAY_TOUCH */.XL.AFTERPAY_TOUCH,
        constants/* PaymentMethod.ZIP_PAY */.XL.ZIP_PAY,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT,
        constants/* PaymentMethod.ALIPAY */.XL.ALIPAY,
        constants/* PaymentMethod.WECHAT_PAY */.XL.WECHAT_PAY, 
    ],
    pdpVideosConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.pdpVideosConfig), {
        numberOfLoops: 2,
        posterSecond: 4
    }),
    priceInputMaxLength: 4,
    priceSliderInterval: 10,
    region: "oceania",
    regionCode: "AUS",
    savedCreditCardTemplate: [
        "new",
        "saved"
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.EN */.lF.EN
    ],
    searchSymbolsMinValue: 2,
    selectablePaymentMethods: [
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD,
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.AFTERPAY_TOUCH */.XL.AFTERPAY_TOUCH,
        constants/* PaymentMethod.ZIP_PAY */.XL.ZIP_PAY,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT,
        constants/* PaymentMethod.ALIPAY */.XL.ALIPAY,
        constants/* PaymentMethod.WECHAT_PAY */.XL.WECHAT_PAY, 
    ],
    socialMediaLinks: {
        facebook: "https://www.facebook.com/pumaaustralia",
        instagram: "https://instagram.com/pumaau",
        pinterest: "https://www.pinterest.com.au/puma/"
    },
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        addAddressResultErrorDisabled: true,
        allowGuestAccessToOrderDetails: true,
        authorityToLeaveEnabled: true,
        canRemoveWishlistItemsFromPDP: true,
        displayPromoDiscountBreakdown: false,
        enableModelMeasurements: true,
        parcelLabTrackingEnabled: true,
        personalizationEnabled: true,
        popoverLoginEnabled: true,
        productFilterCollapsible: false,
        returnsOnOrderDetailsPage: true,
        showAddAddressButtonInAccountDashboard: false,
        showCookieBanner: true,
        showCookieConsentLayer: true,
        showFinancialIncentivesLink: false,
        showHeaderSubHeaderProductDetail: false,
        showModifiedResetPassFormPopup: false,
        showNewsletterSignupOnOrderConfirmation: false,
        showOrderSummaryAtOrderHistory: true,
        showOrderTrackingNumberInOrderDetails: true,
        showPaymentPartnersInFooter: true,
        showPhoneInCheckout: false,
        showPinterestFooterIcon: true,
        showPriceDifference: true,
        showPromoExclusionMsgAboveProductDetails: true,
        showPromoExclusionMsgInBaseSize: true,
        showSaleBadgeOnProductImageEnabled: true,
        showTimeZoneName: true,
        singInInConfirmationForm: true,
        useNewPaymentForm: true
    }),
    supportedLocales: [
        "en-au"
    ],
    validation: {
        address: {
            line1: "^[a-zA-Z0-9+.,()/\\\"'\\- ]+$",
            line2: "^[a-zA-Z0-9+.,()/\\\"'\\- ]+$"
        },
        email: "^[\\w.%+-]+@[\\w.-]+\\.[\\w]{2,6}$",
        name: {
            length: {
                max: 15,
                min: config.commonConfig.validation.name.length.min
            },
            regex: "^[a-zA-Z'\\- ]*$"
        },
        orderNo: "^[0-9]{9}$",
        password: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#$%^&*.+(){}~?])(?=.{8,})",
        phone: {
            length: {
                max: 15,
                min: config.commonConfig.validation.phone.length.min
            },
            prefix: "+61",
            regex: "^\\+61\\s?(?:[123578]\\s?\\d{4}\\s?\\d{4}|4(?:\\d{2}\\s?\\d{3}\\s?\\d{3}|\\s?\\d{4}\\s?\\d{4}))$"
        },
        postalCode: {
            AU: auPostalCodeValidation
        }
    }
});


/***/ }),

/***/ 58468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
// EXTERNAL MODULE: ./sites/common/fields.ts
var fields = __webpack_require__(50384);
;// CONCATENATED MODULE: ./sites/bg/fields.ts



var BGFieldProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields/* commonFieldsProps */.I), {
    phone: {
        fieldType: "input",
        pattern: "^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$"
    },
    phoneNumber: {
        fieldType: "input",
        pattern: "^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$"
    },
    password: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newPassword: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    currentPassword: {
        fieldType: "password",
        maxLength: 255
    },
    passwordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newPasswordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newResetPassword: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newResetPasswordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    cancelLink: {
        fieldType: "link",
        href: "/account"
    },
    countryCode: {
        fieldType: "dropdown",
        validations: [],
        disabled: true,
        options: [
            {
                label: "Bulgaria",
                value: "BG"
            }
        ]
    },
    streetNumber: {
        fieldType: "google-address-look-up",
        mapAddressLookupResultsToFormValues: [
            {
                resultKey: "streetNumber",
                formKey: "streetNumber"
            },
            {
                resultKey: "street",
                formKey: "address1"
            },
            {
                resultKey: "city",
                formKey: "city"
            },
            {
                resultKey: "postalCode",
                formKey: "postalCode"
            }, 
        ],
        validateOnAddressLookupSelect: false,
        maxLength: 30,
        submitOnUpdate: false,
        validations: [
            "latinLettersOnly"
        ]
    },
    postalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 10,
        validations: [
            "postalCode"
        ]
    },
    billingPostalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 10,
        pattern: "^(([gG][iI][rR] {0,}0[aA]{2})|(([aA][sS][cC][nN]|[sS][tT][hH][lL]|[tT][dD][cC][uU]|[bB][bB][nN][dD]|[bB][iI][qQ][qQ]|[fF][iI][qQ][qQ]|[pP][cC][rR][nN]|[sS][iI][qQ][qQ]|[iT][kK][cC][aA]) {0,}1[zZ]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yxA-HK-XY]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$"
    },
    firstName: {
        fieldType: "input",
        validations: [
            "englishLettersOnly"
        ],
        maxLength: 30
    },
    lastName: {
        fieldType: "input",
        validations: [
            "englishLettersOnly"
        ],
        maxLength: 30
    },
    companyName: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    address1: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    address2: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    city: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/bg/forms.ts




var addressForm = [
    [
        {
            name: "firstName",
            type: "input",
            required: true
        },
        {
            name: "lastName",
            type: "input",
            required: true
        }, 
    ],
    // comment for the moment
    // [{ name: 'companyName', type: 'input' }],
    [
        // this line is not required for the new quick address form we'll keep it commented untill make sure is definitive
        // { name: 'streetNumber', type: 'google-address-look-up', required: false },
        {
            name: "address1",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "address2",
            type: "input"
        }
    ],
    [
        {
            name: "city",
            type: "input",
            required: true
        },
        {
            name: "postalCode",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "countryCode",
            type: "dropdown"
        }
    ], 
];
var BGForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    accountAddress: [
        [
            {
                name: "title",
                type: "input",
                required: true
            }
        ], 
    ].concat((0,_to_consumable_array/* default */.Z)(addressForm), [
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }
        ],
        [
            {
                name: "preferred",
                type: "checkbox"
            }
        ], 
    ]),
    checkoutAddress: (0,_to_consumable_array/* default */.Z)(addressForm),
    checkoutContactInfo: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }, 
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ], 
    ],
    checkoutContactInfoNoSubscription: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }, 
        ], 
    ],
    createAccountInConfirmation: [
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "passwordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "register",
                type: "button",
                buttonType: "submit"
            },
            {
                name: "blank",
                type: "blank"
            }, 
        ], 
    ],
    editProfile: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    changePassword: [
        [
            {
                name: "currentPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPasswordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    resetPassword: [
        [
            {
                name: "newResetPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newResetPasswordConfirmation",
                type: "password",
                required: true
            }, 
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            },
            {
                name: "cancelLink",
                type: "link"
            }, 
        ], 
    ]
});

;// CONCATENATED MODULE: ./sites/bg/states.ts
var bgStates = [];

;// CONCATENATED MODULE: ./sites/bg/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files








var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    addressCountries: [
        {
            label: "Bulgaria",
            value: constants/* SUPPORTED_COUNTRY.BG */.bM.BG
        }
    ],
    addressFormat: [
        [
            "firstName",
            "lastName"
        ],
        [
            "address1",
            "address2"
        ],
        [
            "city"
        ],
        [
            "postalCode"
        ],
        [
            "countryCode"
        ], 
    ],
    addressFormatOneLiner: "@{firstName} @{lastName}, @{address1} @{address2} @{city}, @{postalCode} @{countryCode}",
    addressSearch: {
        billing: [
            "BG"
        ],
        shipping: [
            "BG"
        ]
    },
    addressStates: {
        BG: bgStates
    },
    analytics: {
        releaseVersion: "Bulgaria | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [
        "visa",
        "masterCard",
        "maestro",
        "discover"
    ],
    badgeIdsExcludedBySaleStatus: [],
    bloomreach: {
        objectName: "br_data",
        viewId: "bg"
    },
    charactersNeededToSubmitSearch: 1,
    cookieConsent: {
        documentLanguage: true,
        provider: "OneTrust"
    },
    countryCode: "bg",
    countryName: "Bulgaria",
    currency: {
        code: "EUR",
        decimalsToDisplay: 2,
        symbol: "€"
    },
    defaultPaymentMethod: constants/* PaymentMethod.SCHEME */.XL.SCHEME,
    fieldProps: (0,_object_spread/* default */.Z)({}, BGFieldProps),
    flag: "\uD83C\uDDE7\uD83C\uDDEC",
    forms: (0,_object_spread/* default */.Z)({}, BGForms),
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.DAILY */.ho.DAILY,
    maxCountRecordKeeper: 0,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "profileComponent",
                "passwordComponent",
                "preferencesComponent",
                "ambassadorComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "addressBookComponent",
                "orderHistoryComponent"
            ],
            name: "rightColumn"
        }, 
    ],
    newsletter: {
        contactSources: {
            checkOut: "5",
            footer: "1",
            signUp: "6"
        },
        fields: {
            gender: {
                required: true,
                values: [
                    "male",
                    "female",
                    "noAnswer"
                ]
            }
        }
    },
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByEmail */.G.SearchOrderByEmail,
    orderedPaymentPartners: [
        "visa",
        "master",
        "maestro",
        "payPal",
        "applePay",
        "klarna", 
    ],
    paymentMethodsMixedWithGiftCard: [
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT, 
    ],
    pdpVideosConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.pdpVideosConfig), {
        numberOfLoops: 2,
        posterSecond: 4
    }),
    pixleeId: {
        en: "19802791"
    },
    priceInputMaxLength: 4,
    priceSliderInterval: 5,
    pumaAppDownloadUrl: "https://app.puma.com/web-download-uk",
    region: "europe",
    regionCode: "BG",
    savedCreditCardTemplate: [
        "new",
        "saved"
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.EN */.lF.EN
    ],
    searchSymbolsMinValue: 2,
    selectablePaymentMethods: [
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT, 
    ],
    socialMediaLinks: {
        instagram: "https://instagram.com/puma.uk?igshid=YzAyZWRlMzg="
    },
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        addAddressResultErrorDisabled: true,
        allowGuestAccessToOrderDetails: true,
        ambassadorCardsEnabled: true,
        canRemoveWishlistItemsFromPDP: true,
        delayForterLoad: true,
        displayPromoDiscountBreakdown: false,
        editPasswordResultErrorDisabled: true,
        enableModelMeasurements: true,
        hideEmailNotifications: true,
        hidePickUpWhereYouLetOff: true,
        multipleModelMeasurementEnabled: true,
        parcelLabTrackingEnabled: true,
        popoverLoginEnabled: true,
        productFilterCollapsible: false,
        quickAddressFinder: false,
        removeReturnIframe: true,
        returnsOnOrderDetailsPage: true,
        showAddAddressButtonInAccountDashboard: false,
        showCookieBanner: false,
        showCookieConsentLayer: true,
        showFinancialIncentivesLink: false,
        showFreeShippingCost: true,
        showHeaderSubHeaderProductDetail: false,
        showModifiedResetPassFormPopup: false,
        showNewsletterSignupOnOrderConfirmation: false,
        showOrderSummaryAtOrderHistory: true,
        showOrderTrackingNumberInOrderDetails: true,
        showPaymentPartnersInFooter: true,
        showPhoneInCheckout: false,
        showPinterestFooterIcon: true,
        showPriceDifference: true,
        showPromoExclusionMsgInBaseSize: true,
        showTimeZoneName: true,
        singInInConfirmationForm: true,
        personalizationEnabled: true,
        ukAddressForm: true,
        useNewPaymentForm: true,
        useVerticalMedia: true,
        useDataguard: true
    }),
    supportedLocales: [
        "en-bg"
    ],
    validation: {
        address: {
            length: config.commonConfig.validation.address.length,
            line1: "^[a-zA-Z0-9\xc1\xe1\xc9\xe9\xcd\xed\xd3\xf3\xda\xfa\xdc\xfc\\-/ ' ]*$",
            line2: "^[a-zA-Z0-9-/ ]*$"
        },
        companyName: {
            length: {
                max: 50,
                min: 0
            }
        },
        email: "^[\\w.%+-]+@[\\w.-]+\\.[\\w]{2,6}$",
        name: {
            length: config.commonConfig.validation.name.length
        },
        password: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&*.+(){}~?])(?=.{12,})",
        phone: {
            length: {
                max: 30,
                min: config.commonConfig.validation.phone.length.min
            },
            regex: "^.*$"
        },
        postalCode: {
            BG: "^(GIR[ ]?0AA)|((([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][ABCDEFGHJKSTUW])|([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][ABEHMNPRVWXY]))))[ ]?[0-9][ABDEFGHJLNPQRSTUWXYZ]{2})$"
        }
    }
});


/***/ }),

/***/ 48030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
// EXTERNAL MODULE: ./sites/common/fields.ts
var fields = __webpack_require__(50384);
// EXTERNAL MODULE: ./sites/us/validations.ts
var validations = __webpack_require__(26995);
// EXTERNAL MODULE: ./sites/us/states.ts
var states = __webpack_require__(79353);
// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/ca/forms.ts



var CAForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    orderLookUpReturns: [
        [
            {
                name: "orderNo",
                type: "input",
                inputType: "text",
                required: true
            }, 
        ],
        [
            {
                name: "orderEmail",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "billingPostalCode",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "returnsOrderExplainerModal",
                type: "text-to-modal",
                required: true
            }, 
        ],
        [
            {
                name: "submitButton",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ]
});

// EXTERNAL MODULE: ./sites/ca/validations.ts
var ca_validations = __webpack_require__(41174);
// EXTERNAL MODULE: ./sites/ca/states.ts
var ca_states = __webpack_require__(21027);
;// CONCATENATED MODULE: ./sites/ca/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files











var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    addressCountries: [
        {
            label: "United States",
            value: constants/* SUPPORTED_COUNTRY.US */.bM.US
        },
        {
            label: "Canada",
            value: constants/* SUPPORTED_COUNTRY.CA */.bM.CA
        }, 
    ],
    addressFormatOneLiner: "@{salutation} @{firstName} @{lastName}, @{streetNumber} @{address1}, @{city}, @{postalCode} @{stateCode} @{countryCode}",
    addressFormatOneLinerWithAddress2: "@{salutation} @{firstName} @{lastName}, @{streetNumber} @{address1}, @{address2}, @{city}, @{postalCode} @{stateCode} @{countryCode}",
    addressSearch: {
        billing: [
            "CA",
            "US"
        ],
        shipping: [
            "CA"
        ]
    },
    addressStates: {
        CA: ca_states/* caStates */.O,
        US: states/* usStates */.u
    },
    analytics: {
        releaseVersion: "North America | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [
        "visa",
        "masterCard",
        "amex",
        "discover"
    ],
    badgeIdsExcludedBySaleStatus: [],
    bloomreach: {
        objectName: "br_data",
        seoObjectName: "br_data_6251",
        viewId: "ca"
    },
    branchAnalyticsData: {
        agencyId: "1000075349268124316"
    },
    charactersNeededToSubmitSearch: 1,
    countryCode: "ca",
    countryName: "Canada",
    currency: {
        code: "CAD",
        decimalsToDisplay: 2,
        symbol: "CAD $"
    },
    defaultPaymentMethod: constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
    emarsysMerchantId: "1A34C1421884D313",
    enableEstimatedDeliverDatesByItem: true,
    fieldProps: fields/* commonFieldsProps */.I,
    flag: "\uD83C\uDDE8\uD83C\uDDE6",
    forms: (0,_object_spread/* default */.Z)({}, CAForms),
    liveChat: {
        code: "pumacagr",
        provider: "ada",
        script: "https://static.ada.support/embed2.js"
    },
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.WEEKLY */.ho.WEEKLY,
    maxCountRecordKeeper: 0,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "profileComponent",
                "passwordComponent",
                "preferencesComponent",
                "ambassadorComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "addressBookComponent",
                "orderHistoryComponent"
            ],
            name: "rightColumn"
        }, 
    ],
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByEmailPostcode */.G.SearchOrderByEmailPostcode,
    orderedPaymentPartners: [
        "visa",
        "master",
        "americanExpress",
        "payPal",
        "afterPay",
        "klarna",
        "applePay",
        "googlePay", 
    ],
    paymentMethodsMixedWithGiftCard: [
        constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
        constants/* PaymentMethod.AFTERPAY */.XL.AFTERPAY,
        constants/* PaymentMethod.KLARNA_PAYMENTS */.XL.KLARNA_PAYMENTS, 
    ],
    phoneAnchorNumberInCheckout: "tel:18885657862",
    phoneTextNumberInCheckout: "1-888-565-PUMA (7862)",
    pixleeId: {
        en: "1233838",
        fr: "1988018"
    },
    priceInputMaxLength: 4,
    priceSliderInterval: 10,
    pumaAppDownloadUrl: "https://app.puma.com/web-download",
    region: "na",
    regionCode: "PNA",
    savedCreditCardTemplate: [
        "new",
        "saved"
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.EN */.lF.EN,
        constants/* SUPPORTED_LANGUAGE.FR */.lF.FR, 
    ],
    searchSymbolsMinValue: 2,
    selectablePaymentMethods: [
        constants/* PaymentMethod.AFTERPAY */.XL.AFTERPAY,
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD,
        constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
        constants/* PaymentMethod.KLARNA_PAYMENTS */.XL.KLARNA_PAYMENTS, 
    ],
    stateFieldLabels: {
        CA: {
            label: "provinceOrTerritory",
            placeholder: "selectProviceOrTerritory"
        }
    },
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        allowGuestAccessToOrderDetails: false,
        canRemoveWishlistItemsFromPDP: false,
        displayPromoDiscountBreakdown: false,
        enableModelMeasurements: true,
        enablePopularity: true,
        enableRrdTracking: true,
        giftWithPurchaseNewDesign: true,
        isPNARegion: true,
        multipleModelMeasurementEnabled: true,
        popoverLoginEnabled: true,
        productFilterCollapsible: false,
        quickAddressFinder: true,
        removeReturnIframe: true,
        returnsOnOrderDetailsPage: false,
        shapeSecurity: true,
        showAddAddressButtonInAccountDashboard: false,
        showCookieBanner: true,
        showCookieConsentLayer: true,
        showFinancialIncentivesLink: false,
        showFreeShippingCost: true,
        showFreeShippingProgressBar: true,
        showHeaderSubHeaderProductDetail: true,
        showModifiedResetPassFormPopup: false,
        showPaymentPartnersInFooter: false,
        showPhoneInCheckout: true,
        showPinterestFooterIcon: true,
        showPriceDifference: true,
        showPromoExclusionMsgAboveProductDetails: true,
        showPromoExclusionMsgInBaseSize: true,
        showTimeZoneName: true,
        singInInConfirmationForm: false,
        triggerCartTotalEvent: true,
        useMasterIdsInCartRecommenders: true,
        useNewPaymentForm: true
    }),
    supportedLocales: [
        "en-ca",
        "fr-ca"
    ],
    validation: {
        address: {
            length: config.commonConfig.validation.address.length,
            line1: "([0-9]+[\\u0000-~\\u0080-ž'\"]+$)|([\\u0000-~\\u0080-ž'\"]+[0-9]+$)|[p|P][\\s]*[o|O][\\s]*[b|B][\\s]*[o|O][\\s]*[x|X][\\s]*[a-zA-Z0-9]*|\\b[P|p]+(OST|ost|o|O)?\\.?\\s*[O|o|0]+(ffice|FFICE)?\\.?\\s*[B|b][O|o|0]?[X|x]+\\.?\\s+[#]?(\\d+)*(\\D+)*\\b"
        },
        companyName: {
            length: {
                max: 50,
                min: 0
            }
        },
        email: "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
        name: {
            length: config.commonConfig.validation.name.length
        },
        phone: {
            length: {
                max: 30,
                min: config.commonConfig.validation.phone.length.min
            },
            regex: "^(?:[\\s.()-]*(1|\\+1|001)[\\s.()-]*)?[\\s.()-]*[2-9][0-9]{2}[\\s.()-]*[2-9][0-9]{2}[\\s.()-]*[0-9]{4}[\\s.()-]*$"
        },
        postalCode: {
            CA: ca_validations/* caPostalCodeValidation */.J,
            US: validations/* usPostalCodeValidation */.c
        }
    }
});


/***/ }),

/***/ 21027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ caStates; }
/* harmony export */ });
var caStates = [
    {
        name: "Alberta",
        value: "AB"
    },
    {
        name: "British Columbia",
        value: "BC"
    },
    {
        name: "Manitoba",
        value: "MB"
    },
    {
        name: "New Brunswick",
        value: "NB"
    },
    {
        name: "Newfoundland and Labrador",
        value: "NL"
    },
    {
        name: "Northwest Territories",
        value: "NT"
    },
    {
        name: "Nova Scotia",
        value: "NS"
    },
    {
        name: "Nunavut",
        value: "NU"
    },
    {
        name: "Ontario",
        value: "ON"
    },
    {
        name: "Prince Edward Island",
        value: "PE"
    },
    {
        name: "Quebec",
        value: "QC"
    },
    {
        name: "Saskatchewan",
        value: "SK"
    },
    {
        name: "Yukon Territory",
        value: "YT"
    }, 
];


/***/ }),

/***/ 41174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ caPostalCodeValidation; }
/* harmony export */ });
var caPostalCodeValidation = "^[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][\\s]{1}\\d[ABCEGHJ-NPRSTV-Z]\\d$";


/***/ }),

/***/ 26345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/in/forms.ts



var INForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    editPhone: [
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }, 
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    editProfile: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }, 
        ],
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }, 
        ],
        [
            {
                name: "gender",
                type: "input-radio"
            }, 
        ],
        [
            {
                name: "birthday",
                type: "birthday",
                required: true
            }, 
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    checkoutAddress: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            },
            {
                name: "lastName",
                type: "input",
                required: true
            }, 
        ],
        [
            {
                name: "postalCode",
                type: "pincode",
                required: true
            }
        ],
        [
            {
                name: "address1",
                type: "google-address-look-up",
                required: true
            }, 
        ],
        [
            {
                name: "address2",
                type: "input"
            }
        ],
        [
            {
                name: "city",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "stateCode",
                type: "dropdown",
                required: true
            },
            {
                name: "countryCode",
                type: "dropdown"
            }, 
        ], 
    ],
    orderLookUpReturns: [
        [
            {
                name: "orderNo",
                type: "input",
                inputType: "text",
                required: true
            }, 
        ],
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }
        ],
        [
            {
                name: "returnsOrderExplainerModal",
                type: "text-to-modal",
                required: true
            }, 
        ],
        [
            {
                name: "submitButton",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ]
});

// EXTERNAL MODULE: ./sites/common/fields.ts
var fields = __webpack_require__(50384);
// EXTERNAL MODULE: ./sites/in/states.ts
var states = __webpack_require__(75750);
;// CONCATENATED MODULE: ./sites/in/fields.ts




var INFieldProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields/* commonFieldsProps */.I), {
    firstName: {
        fieldType: "input",
        validations: [
            "name"
        ],
        maxLength: 50
    },
    lastName: {
        fieldType: "input",
        validations: [
            "name"
        ],
        maxLength: 50
    },
    password: {
        fieldType: "password",
        validations: [
            "password"
        ],
        minLength: 8,
        maxLength: 255
    },
    gender: {
        fieldType: "input-radio",
        values: [
            "male",
            "female"
        ]
    },
    phone: {
        fieldType: "input",
        prefix: "+91",
        validations: [
            "phoneNumber"
        ]
    },
    countryCode: {
        fieldType: "dropdown",
        validations: [],
        disabled: true,
        options: [
            {
                label: "India",
                value: "IN"
            }
        ]
    },
    postalCode: {
        fieldType: "pincode",
        mapAddressLookupResultsToFormValues: [
            {
                resultKey: "stateCode",
                formKey: "stateCode"
            },
            {
                resultKey: "street",
                formKey: "address1"
            },
            {
                resultKey: "city",
                formKey: "city"
            }, 
        ],
        minLength: 6,
        maxLength: 6,
        validations: [
            "postalCode"
        ]
    },
    stateCode: {
        fieldType: "dropdown",
        options: states/* inStates.map */.k.map(function(state) {
            return {
                value: state.value,
                label: state.name
            };
        })
    },
    address1: {
        fieldType: "google-address-look-up",
        mapAddressLookupResultsToFormValues: [
            {
                resultKey: "stateCode",
                formKey: "stateCode"
            },
            {
                resultKey: "address1",
                formKey: "address1"
            },
            {
                resultKey: "city",
                formKey: "city"
            },
            {
                resultKey: "postalCode",
                formKey: "postalCode"
            }, 
        ],
        validateOnAddressLookupSelect: false,
        maxLength: 50,
        submitOnUpdate: false,
        validations: [
            "addressLine1"
        ]
    },
    address2: {
        fieldType: "input",
        validations: [
            "addressLine2"
        ],
        maxLength: 50
    }
});

;// CONCATENATED MODULE: ./sites/in/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files








var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    addressCountries: [
        {
            label: "India",
            value: constants/* SUPPORTED_COUNTRY.IN */.bM.IN
        }
    ],
    addressSearch: {
        billing: [
            "IN"
        ],
        shipping: [
            "IN"
        ]
    },
    addressStates: {
        IN: states/* inStates */.k
    },
    analytics: {
        releaseVersion: "India | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [],
    badgeIdsExcludedBySaleStatus: [],
    bloomreach: {
        objectName: "br_data",
        viewId: "in"
    },
    branchAnalyticsData: {
        agencyId: "1000067495857508873"
    },
    charactersNeededToSubmitSearch: 3,
    countryCode: "in",
    countryName: "India",
    currency: {
        code: "INR",
        decimalsToDisplay: 0,
        symbol: "₹"
    },
    fieldProps: INFieldProps,
    flag: "\uD83C\uDDEE\uD83C\uDDF3",
    forms: (0,_object_spread/* default */.Z)({}, INForms),
    insiderIntegration: {
        partnerId: "10006083",
        partnerName: "pumaindia"
    },
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.DAILY */.ho.DAILY,
    maxCountRecordKeeper: 0,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "profileComponent",
                "passwordComponent",
                "phoneComponent",
                "preferencesComponent",
                "ambassadorComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "addressBookComponent",
                "orderHistoryComponent"
            ],
            name: "rightColumn"
        }, 
    ],
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByPhone */.G.SearchOrderByPhone,
    orderedPaymentPartners: [
        "visa",
        "master",
        "maestro",
        "americanExpress",
        "UPI",
        "rupay", 
    ],
    paymentMethodsMixedWithGiftCard: [],
    pixleeId: {
        en: "2106280"
    },
    priceInputMaxLength: 5,
    priceSliderInterval: 500,
    pumaAppDownloadUrl: "https://app.puma.com/web-download-in",
    region: "asia",
    regionCode: "IND",
    savedCreditCardTemplate: [
        "new",
        "saved"
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.EN */.lF.EN
    ],
    searchSymbolsMinValue: 3,
    selectablePaymentMethods: [
        constants/* PaymentMethod.RAZORPAY */.XL.RAZORPAY,
        constants/* PaymentMethod.UPI */.XL.UPI,
        constants/* PaymentMethod.UPI_COLLECT */.XL.UPI_COLLECT,
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.NET_BANKING_DEPRECATED */.XL.NET_BANKING_DEPRECATED,
        constants/* PaymentMethod.ONLINE_BANKING_IN */.XL.ONLINE_BANKING_IN,
        constants/* PaymentMethod.WALLET */.XL.WALLET,
        constants/* PaymentMethod.PAYTM */.XL.PAYTM,
        constants/* PaymentMethod.COD */.XL.COD, 
    ],
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        allowGuestAccessToOrderDetails: true,
        canRemoveWishlistItemsFromPDP: true,
        displayPromoDiscountBreakdown: false,
        enableItemLinksInCartSummary: true,
        enableModelMeasurements: true,
        hideEmailNotifications: true,
        hidePickUpWhereYouLetOff: true,
        hideWeightInProductMeasurements: true,
        personalizationEnabled: true,
        popoverLoginEnabled: true,
        productFilterCollapsible: false,
        returnsOnOrderDetailsPage: true,
        searchLocalImagesOnProductComparison: true,
        showAddAddressButtonInAccountDashboard: false,
        showCookieBanner: true,
        showFinancialIncentivesLink: false,
        showFreeShippingCost: true,
        showHeaderSubHeaderProductDetail: false,
        showModifiedResetPassFormPopup: false,
        showPaymentPartnersInFooter: true,
        showPhoneInCheckout: false,
        showPinterestFooterIcon: true,
        showPriceDifference: true,
        showPromoExclusionMsgAboveProductDetails: true,
        showPromoExclusionMsgInBaseSize: true,
        showSaleBadgeOnProductImageEnabled: true,
        singInInConfirmationForm: false,
        showCookieConsentLayer: true,
        useNewPaymentForm: true,
        useProductSizeChart: true,
        isSalesfloorEnabled: true,
        otpLoginEnabled: true
    }),
    supportedLocales: [
        "en-in"
    ],
    validation: {
        address: {
            length: config.commonConfig.validation.address.length,
            line1: "^[a-zA-Z0-9-\\/#., \\\\]*$",
            line2: "^[a-zA-Z0-9-\\/#., \\\\]*$",
            title: "^[a-zA-Z0-9 ]*$"
        },
        email: "^[\\w.%+-]+@[\\w.-]+\\.[\\w]{2,6}$",
        name: {
            length: config.commonConfig.validation.name.length,
            regex: "^[a-zA-Z]+(?: [a-zA-Z]+)*$"
        },
        orderNo: "^(?:\\d{8,9}|INSTG\\d{8})$",
        password: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&*.+(){}~?])(?=.{8,})",
        phone: {
            length: {
                max: 13,
                min: config.commonConfig.validation.phone.length.min
            },
            prefix: "+91",
            regex: "^\\+91[0-9]{10}$"
        },
        postalCode: {
            IN: "^[1-9][0-9]{5}$"
        }
    }
});


/***/ }),

/***/ 49201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _au_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9129);
/* harmony import */ var _ca_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48030);
/* harmony import */ var _gb_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11924);
/* harmony import */ var _in_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26345);
/* harmony import */ var _jp_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24878);
/* harmony import */ var _us_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76801);
/* harmony import */ var _bg_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58468);
/* harmony import */ var _lt_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42081);






// eu migration


var sites = {
    AU: _au_config__WEBPACK_IMPORTED_MODULE_0__.config,
    CA: _ca_config__WEBPACK_IMPORTED_MODULE_1__.config,
    GB: _gb_config__WEBPACK_IMPORTED_MODULE_2__.config,
    IN: _in_config__WEBPACK_IMPORTED_MODULE_3__.config,
    JP: _jp_config__WEBPACK_IMPORTED_MODULE_4__.config,
    US: _us_config__WEBPACK_IMPORTED_MODULE_5__.config,
    // eu migration
    BG: _bg_config__WEBPACK_IMPORTED_MODULE_6__.config,
    LT: _lt_config__WEBPACK_IMPORTED_MODULE_7__.config
};
/* harmony default export */ __webpack_exports__["Z"] = (sites);


/***/ }),

/***/ 42081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
// EXTERNAL MODULE: ./sites/common/fields.ts
var fields = __webpack_require__(50384);
;// CONCATENATED MODULE: ./sites/lt/fields.ts



var LTFieldProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields/* commonFieldsProps */.I), {
    phone: {
        fieldType: "input",
        pattern: "^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$"
    },
    phoneNumber: {
        fieldType: "input",
        pattern: "^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$"
    },
    password: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newPassword: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    currentPassword: {
        fieldType: "password",
        maxLength: 255
    },
    passwordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newPasswordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newResetPassword: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newResetPasswordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    cancelLink: {
        fieldType: "link",
        href: "/account"
    },
    countryCode: {
        fieldType: "dropdown",
        validations: [],
        disabled: true,
        options: [
            {
                label: "Lithuania",
                value: "LT"
            }
        ]
    },
    streetNumber: {
        fieldType: "google-address-look-up",
        mapAddressLookupResultsToFormValues: [
            {
                resultKey: "streetNumber",
                formKey: "streetNumber"
            },
            {
                resultKey: "street",
                formKey: "address1"
            },
            {
                resultKey: "city",
                formKey: "city"
            },
            {
                resultKey: "postalCode",
                formKey: "postalCode"
            }, 
        ],
        validateOnAddressLookupSelect: false,
        maxLength: 30,
        submitOnUpdate: false,
        validations: [
            "latinLettersOnly"
        ]
    },
    postalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 10,
        validations: [
            "postalCode"
        ]
    },
    billingPostalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 10,
        pattern: "^(([gG][iI][rR] {0,}0[aA]{2})|(([aA][sS][cC][nN]|[sS][tT][hH][lL]|[tT][dD][cC][uU]|[bB][bB][nN][dD]|[bB][iI][qQ][qQ]|[fF][iI][qQ][qQ]|[pP][cC][rR][nN]|[sS][iI][qQ][qQ]|[iT][kK][cC][aA]) {0,}1[zZ]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yxA-HK-XY]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$"
    },
    firstName: {
        fieldType: "input",
        validations: [
            "englishLettersOnly"
        ],
        maxLength: 30
    },
    lastName: {
        fieldType: "input",
        validations: [
            "englishLettersOnly"
        ],
        maxLength: 30
    },
    companyName: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    address1: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    address2: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    city: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/lt/forms.ts




var addressForm = [
    [
        {
            name: "firstName",
            type: "input",
            required: true
        },
        {
            name: "lastName",
            type: "input",
            required: true
        }, 
    ],
    // comment for the moment
    // [{ name: 'companyName', type: 'input' }],
    [
        // this line is not required for the new quick address form we'll keep it commented untill make sure is definitive
        // { name: 'streetNumber', type: 'google-address-look-up', required: false },
        {
            name: "address1",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "address2",
            type: "input"
        }
    ],
    [
        {
            name: "city",
            type: "input",
            required: true
        },
        {
            name: "postalCode",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "countryCode",
            type: "dropdown"
        }
    ], 
];
var LTForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    accountAddress: [
        [
            {
                name: "title",
                type: "input",
                required: true
            }
        ], 
    ].concat((0,_to_consumable_array/* default */.Z)(addressForm), [
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }
        ],
        [
            {
                name: "preferred",
                type: "checkbox"
            }
        ], 
    ]),
    checkoutAddress: (0,_to_consumable_array/* default */.Z)(addressForm),
    checkoutContactInfo: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }, 
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ], 
    ],
    checkoutContactInfoNoSubscription: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }, 
        ], 
    ],
    createAccountInConfirmation: [
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "passwordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "register",
                type: "button",
                buttonType: "submit"
            },
            {
                name: "blank",
                type: "blank"
            }, 
        ], 
    ],
    editProfile: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    changePassword: [
        [
            {
                name: "currentPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPasswordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    resetPassword: [
        [
            {
                name: "newResetPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newResetPasswordConfirmation",
                type: "password",
                required: true
            }, 
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            },
            {
                name: "cancelLink",
                type: "link"
            }, 
        ], 
    ]
});

;// CONCATENATED MODULE: ./sites/lt/states.ts
var ltStates = [];

;// CONCATENATED MODULE: ./sites/lt/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files








var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    addressCountries: [
        {
            label: "Lithuania",
            value: constants/* SUPPORTED_COUNTRY.LT */.bM.LT
        }
    ],
    addressFormat: [
        [
            "firstName",
            "lastName"
        ],
        [
            "address1",
            "address2"
        ],
        [
            "city"
        ],
        [
            "postalCode"
        ],
        [
            "countryCode"
        ], 
    ],
    addressFormatOneLiner: "@{firstName} @{lastName}, @{address1} @{address2} @{city}, @{postalCode} @{countryCode}",
    addressSearch: {
        billing: [
            "LT"
        ],
        shipping: [
            "LT"
        ]
    },
    addressStates: {
        LT: ltStates
    },
    analytics: {
        releaseVersion: "Lithuania | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [
        "visa",
        "masterCard",
        "maestro",
        "discover"
    ],
    badgeIdsExcludedBySaleStatus: [],
    bloomreach: {
        objectName: "br_data",
        viewId: "lt"
    },
    charactersNeededToSubmitSearch: 1,
    cookieConsent: {
        documentLanguage: true,
        provider: "OneTrust"
    },
    countryCode: "lt",
    countryName: "Lithuania",
    currency: {
        code: "EUR",
        decimalsToDisplay: 2,
        symbol: "€"
    },
    defaultPaymentMethod: constants/* PaymentMethod.SCHEME */.XL.SCHEME,
    fieldProps: (0,_object_spread/* default */.Z)({}, LTFieldProps),
    flag: "\uD83C\uDDF1\uD83C\uDDF9",
    forms: (0,_object_spread/* default */.Z)({}, LTForms),
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.DAILY */.ho.DAILY,
    maxCountRecordKeeper: 0,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "profileComponent",
                "passwordComponent",
                "preferencesComponent",
                "ambassadorComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "addressBookComponent",
                "orderHistoryComponent"
            ],
            name: "rightColumn"
        }, 
    ],
    newsletter: {
        contactSources: {
            checkOut: "5",
            footer: "1",
            signUp: "6"
        },
        fields: {
            gender: {
                required: true,
                values: [
                    "male",
                    "female",
                    "noAnswer"
                ]
            }
        }
    },
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByEmail */.G.SearchOrderByEmail,
    orderedPaymentPartners: [
        "visa",
        "master",
        "maestro",
        "payPal",
        "applePay",
        "klarna", 
    ],
    paymentMethodsMixedWithGiftCard: [
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT, 
    ],
    pdpVideosConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.pdpVideosConfig), {
        numberOfLoops: 2,
        posterSecond: 4
    }),
    pixleeId: {
        en: "19802791"
    },
    priceInputMaxLength: 4,
    priceSliderInterval: 5,
    pumaAppDownloadUrl: "https://app.puma.com/web-download-uk",
    region: "europe",
    regionCode: "LT",
    savedCreditCardTemplate: [
        "new",
        "saved"
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.EN */.lF.EN
    ],
    searchSymbolsMinValue: 2,
    selectablePaymentMethods: [
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT, 
    ],
    socialMediaLinks: {
        instagram: "https://instagram.com/puma.uk?igshid=YzAyZWRlMzg="
    },
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        addAddressResultErrorDisabled: true,
        allowGuestAccessToOrderDetails: true,
        ambassadorCardsEnabled: true,
        canRemoveWishlistItemsFromPDP: true,
        delayForterLoad: true,
        displayPromoDiscountBreakdown: false,
        editPasswordResultErrorDisabled: true,
        enableModelMeasurements: true,
        hideEmailNotifications: true,
        hidePickUpWhereYouLetOff: true,
        multipleModelMeasurementEnabled: true,
        parcelLabTrackingEnabled: true,
        popoverLoginEnabled: true,
        productFilterCollapsible: false,
        quickAddressFinder: false,
        removeReturnIframe: true,
        returnsOnOrderDetailsPage: true,
        showAddAddressButtonInAccountDashboard: false,
        showCookieBanner: false,
        showCookieConsentLayer: true,
        showFinancialIncentivesLink: false,
        showFreeShippingCost: true,
        showHeaderSubHeaderProductDetail: false,
        showModifiedResetPassFormPopup: false,
        showNewsletterSignupOnOrderConfirmation: false,
        showOrderSummaryAtOrderHistory: true,
        showOrderTrackingNumberInOrderDetails: true,
        showPaymentPartnersInFooter: true,
        showPhoneInCheckout: false,
        showPinterestFooterIcon: true,
        showPriceDifference: true,
        showPromoExclusionMsgInBaseSize: true,
        showTimeZoneName: true,
        singInInConfirmationForm: true,
        personalizationEnabled: true,
        ukAddressForm: true,
        useNewPaymentForm: true,
        useVerticalMedia: true,
        useDataguard: true
    }),
    supportedLocales: [
        "en-lt"
    ],
    validation: {
        address: {
            length: config.commonConfig.validation.address.length,
            line1: "^[a-zA-Z0-9\xc1\xe1\xc9\xe9\xcd\xed\xd3\xf3\xda\xfa\xdc\xfc\\-/ ' ]*$",
            line2: "^[a-zA-Z0-9-/ ]*$"
        },
        companyName: {
            length: {
                max: 50,
                min: 0
            }
        },
        email: "^[\\w.%+-]+@[\\w.-]+\\.[\\w]{2,6}$",
        name: {
            length: config.commonConfig.validation.name.length
        },
        password: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&*.+(){}~?])(?=.{12,})",
        phone: {
            length: {
                max: 30,
                min: config.commonConfig.validation.phone.length.min
            },
            regex: "^.*$"
        },
        postalCode: {
            LT: "^(GIR[ ]?0AA)|((([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][ABCDEFGHJKSTUW])|([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][ABEHMNPRVWXY]))))[ ]?[0-9][ABDEFGHJLNPQRSTUWXYZ]{2})$"
        }
    }
});


/***/ }),

/***/ 76801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
// EXTERNAL MODULE: ./sites/common/fields.ts
var fields = __webpack_require__(50384);
// EXTERNAL MODULE: ./sites/ca/validations.ts
var validations = __webpack_require__(41174);
// EXTERNAL MODULE: ./sites/ca/states.ts
var states = __webpack_require__(21027);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
;// CONCATENATED MODULE: ./config/incomplete-features.ts
/**
 * The SMS Opt-In feature will be completed in small parts,
 * which must be released together.
 * Epic: https://pumaglobal.atlassian.net/browse/EPIC-24
 */ var SMS_OPT_IN_FEATURE_READY = false;

// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/us/forms.ts





var USForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    registration: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ], 
    ].concat((0,_to_consumable_array/* default */.Z)(!SMS_OPT_IN_FEATURE_READY ? [] : [
        [
            {
                name: "smsOptIn",
                type: "sms-opt-in",
                args: {
                    phoneNumberFieldName: "phoneNumber",
                    ctaLabel: "register"
                }
            }, 
        ], 
    ]), [
        [
            {
                name: "tacOnCreateAccount",
                type: "terms-and-conditions"
            }
        ],
        [
            {
                name: "createAccount",
                type: "button",
                buttonType: "submit"
            }
        ], 
    ]),
    orderLookUpReturns: [
        [
            {
                name: "orderNo",
                type: "input",
                inputType: "text",
                required: true
            }, 
        ],
        [
            {
                name: "orderEmail",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "billingPostalCode",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "returnsOrderExplainerModal",
                type: "text-to-modal",
                required: true
            }, 
        ],
        [
            {
                name: "submitButton",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ]
});

// EXTERNAL MODULE: ./sites/us/validations.ts
var us_validations = __webpack_require__(26995);
// EXTERNAL MODULE: ./sites/us/states.ts
var us_states = __webpack_require__(79353);
;// CONCATENATED MODULE: ./sites/us/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files











var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    addressCountries: [
        {
            label: "United States",
            value: constants/* SUPPORTED_COUNTRY.US */.bM.US
        },
        {
            label: "Canada",
            value: constants/* SUPPORTED_COUNTRY.CA */.bM.CA
        }, 
    ],
    addressFormatOneLiner: "@{salutation} @{firstName} @{lastName}, @{streetNumber} @{address1}, @{city}, @{stateCode} @{postalCode} @{countryCode}",
    addressFormatOneLinerWithAddress2: "@{salutation} @{firstName} @{lastName}, @{streetNumber} @{address1}, @{address2}, @{city}, @{stateCode} @{postalCode} @{countryCode}",
    addressSearch: {
        billing: [
            "US",
            "CA"
        ],
        shipping: [
            "US",
            "GU"
        ]
    },
    addressStates: {
        US: us_states/* usStates */.u,
        CA: states/* caStates */.O
    },
    analytics: {
        releaseVersion: "North America | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [
        "visa",
        "masterCard",
        "amex",
        "discover"
    ],
    badgeIdsExcludedBySaleStatus: [],
    bloomreach: {
        objectName: "br_data",
        viewId: "us"
    },
    branchAnalyticsData: {
        agencyId: "1000075349268124316"
    },
    charactersNeededToSubmitSearch: 1,
    countryCode: "us",
    countryName: "United States",
    currency: {
        code: "USD",
        decimalsToDisplay: 2,
        symbol: "$"
    },
    defaultPaymentMethod: constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
    emarsysMerchantId: "123C47C34BB8738C",
    enableEstimatedDeliverDatesByItem: true,
    fieldProps: fields/* commonFieldsProps */.I,
    flag: "\uD83C\uDDFA\uD83C\uDDF8",
    forms: (0,_object_spread/* default */.Z)({}, USForms),
    liveChat: {
        code: "pumagr",
        provider: "ada",
        script: "https://static.ada.support/embed2.js"
    },
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.WEEKLY */.ho.WEEKLY,
    maxCountRecordKeeper: 0,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "profileComponent",
                "passwordComponent",
                "preferencesComponent",
                "ambassadorComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "addressBookComponent",
                "orderHistoryComponent"
            ],
            name: "rightColumn"
        }, 
    ],
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByEmailPostcode */.G.SearchOrderByEmailPostcode,
    orderedPaymentPartners: [
        "visa",
        "master",
        "americanExpress",
        "discover",
        "payPal",
        "afterPay",
        "klarna",
        "applePay",
        "googlePay", 
    ],
    paymentMethodsMixedWithGiftCard: [
        constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
        constants/* PaymentMethod.AFTERPAY */.XL.AFTERPAY,
        // I comment this since Klarna has a feature flag
        // when Klarna is enabled again, we have to remove this change
        constants/* PaymentMethod.KLARNA_PAYMENTS */.XL.KLARNA_PAYMENTS, 
    ],
    phoneAnchorNumberInCheckout: "tel:18885657862",
    phoneTextNumberInCheckout: "1-888-565-PUMA (7862)",
    pixleeId: {
        en: "2772278",
        es: "2772278"
    },
    priceInputMaxLength: 4,
    priceSliderInterval: 5,
    pumaAppDownloadUrl: "https://app.puma.com/web-download",
    region: "na",
    regionCode: "PNA",
    savedCreditCardTemplate: [
        "new",
        "saved"
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.EN */.lF.EN,
        constants/* SUPPORTED_LANGUAGE.ES */.lF.ES, 
    ],
    searchSymbolsMinValue: 2,
    selectablePaymentMethods: [
        constants/* PaymentMethod.AFTERPAY */.XL.AFTERPAY,
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD,
        constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
        // I comment this since Klarna has a feature flag
        // when Klarna is enabled again, we have to remove this change
        constants/* PaymentMethod.KLARNA_PAYMENTS */.XL.KLARNA_PAYMENTS, 
    ],
    stateFieldLabels: {
        CA: {
            label: "provinceOrTerritory",
            placeholder: "selectProviceOrTerritory"
        }
    },
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        allowGuestAccessToOrderDetails: false,
        ambassadorCardsEnabled: true,
        canRemoveWishlistItemsFromPDP: false,
        displayPromoDiscountBreakdown: false,
        enableModelMeasurements: true,
        enablePopularity: true,
        enableRrdTracking: true,
        giftWithPurchaseNewDesign: true,
        isPNARegion: true,
        multipleModelMeasurementEnabled: true,
        personalizationEnabled: true,
        popoverLoginEnabled: true,
        productFilterCollapsible: false,
        quickAddressFinder: true,
        removeReturnIframe: true,
        returnsOnOrderDetailsPage: false,
        shapeSecurity: true,
        showAddAddressButtonInAccountDashboard: false,
        showCookieBanner: true,
        showCookieConsentLayer: true,
        showFinancialIncentivesLink: true,
        showFreeShippingCost: true,
        showFreeShippingProgressBar: true,
        showHeaderSubHeaderProductDetail: true,
        showKlarnaDisclaimerMessage: true,
        showModifiedResetPassFormPopup: false,
        showPaymentPartnersInFooter: false,
        showPhoneInCheckout: true,
        showPinterestFooterIcon: true,
        showPriceDifference: true,
        showPromoExclusionMsgAboveProductDetails: true,
        showPromoExclusionMsgInBaseSize: true,
        showTimeZoneName: true,
        singInInConfirmationForm: false,
        triggerCartTotalEvent: true,
        useAccountNotificationFormV2: false,
        useNewPaymentForm: true
    }),
    supportedLocales: [
        "en-us",
        "es-us"
    ],
    validation: {
        address: {
            length: config.commonConfig.validation.address.length,
            line1: "([0-9]+[\\u0000-~\\u0080-ž'\"]+$)|([\\u0000-~\\u0080-ž'\"]+[0-9]+$)|[p|P][\\s]*[o|O][\\s]*[b|B][\\s]*[o|O][\\s]*[x|X][\\s]*[a-zA-Z0-9]*|\\b[P|p]+(OST|ost|o|O)?\\.?\\s*[O|o|0]+(ffice|FFICE)?\\.?\\s*[B|b][O|o|0]?[X|x]+\\.?\\s+[#]?(\\d+)*(\\D+)*\\b"
        },
        companyName: {
            length: {
                max: 50,
                min: 0
            }
        },
        email: "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
        name: {
            length: config.commonConfig.validation.name.length
        },
        phone: {
            length: {
                max: 30,
                min: config.commonConfig.validation.phone.length.min
            },
            regex: "^(?:[\\s.()-]*(1|\\+1|001)[\\s.()-]*)?[\\s.()-]*[2-9][0-9]{2}[\\s.()-]*[2-9][0-9]{2}[\\s.()-]*[0-9]{4}[\\s.()-]*$"
        },
        postalCode: {
            US: us_validations/* usPostalCodeValidation */.c,
            CA: validations/* caPostalCodeValidation */.J
        }
    }
});


/***/ }),

/***/ 79353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ usStates; }
/* harmony export */ });
var usStates = [
    {
        name: "Alabama",
        value: "AL"
    },
    {
        name: "Alaska",
        value: "AK"
    },
    {
        name: "American Samoa",
        value: "AS"
    },
    {
        name: "Arizona",
        value: "AZ"
    },
    {
        name: "Arkansas",
        value: "AR"
    },
    {
        name: "California",
        value: "CA"
    },
    {
        name: "Colorado",
        value: "CO"
    },
    {
        name: "Connecticut",
        value: "CT"
    },
    {
        name: "Delaware",
        value: "DE"
    },
    {
        name: "District of Columbia",
        value: "DC"
    },
    {
        name: "Florida",
        value: "FL"
    },
    {
        name: "Georgia",
        value: "GA"
    },
    {
        name: "Guam",
        value: "GU"
    },
    {
        name: "Hawaii",
        value: "HI"
    },
    {
        name: "Idaho",
        value: "ID"
    },
    {
        name: "Illinois",
        value: "IL"
    },
    {
        name: "Indiana",
        value: "IN"
    },
    {
        name: "Iowa",
        value: "IA"
    },
    {
        name: "Kansas",
        value: "KS"
    },
    {
        name: "Kentucky",
        value: "KY"
    },
    {
        name: "Louisiana",
        value: "LA"
    },
    {
        name: "Maine",
        value: "ME"
    },
    {
        name: "Maryland",
        value: "MD"
    },
    {
        name: "Massachusetts",
        value: "MA"
    },
    {
        name: "Michigan",
        value: "MI"
    },
    {
        name: "Minnesota",
        value: "MN"
    },
    {
        name: "Mississippi",
        value: "MS"
    },
    {
        name: "Missouri",
        value: "MO"
    },
    {
        name: "Montana",
        value: "MT"
    },
    {
        name: "Nebraska",
        value: "NE"
    },
    {
        name: "Nevada",
        value: "NV"
    },
    {
        name: "New Hampshire",
        value: "NH"
    },
    {
        name: "New Jersey",
        value: "NJ"
    },
    {
        name: "New Mexico",
        value: "NM"
    },
    {
        name: "New York",
        value: "NY"
    },
    {
        name: "North Carolina",
        value: "NC"
    },
    {
        name: "North Dakota",
        value: "ND"
    },
    {
        name: "Northern Mariana Islands",
        value: "MP"
    },
    {
        name: "Ohio",
        value: "OH"
    },
    {
        name: "Oklahoma",
        value: "OK"
    },
    {
        name: "Oregon",
        value: "OR"
    },
    {
        name: "Pennsylvania",
        value: "PA"
    },
    {
        name: "Puerto Rico",
        value: "PR"
    },
    {
        name: "Rhode Island",
        value: "RI"
    },
    {
        name: "South Carolina",
        value: "SC"
    },
    {
        name: "South Dakota",
        value: "SD"
    },
    {
        name: "Tennessee",
        value: "TN"
    },
    {
        name: "Texas",
        value: "TX"
    },
    {
        name: "US Minor Outlying Islands",
        value: "UM"
    },
    {
        name: "Utah",
        value: "UT"
    },
    {
        name: "Vermont",
        value: "VT"
    },
    {
        name: "Virgin Islands, U.S.",
        value: "VI"
    },
    {
        name: "Virginia",
        value: "VA"
    },
    {
        name: "Washington",
        value: "WA"
    },
    {
        name: "West Virginia",
        value: "WV"
    },
    {
        name: "Wisconsin",
        value: "WI"
    },
    {
        name: "Wyoming",
        value: "WY"
    },
    {
        name: "Armed Forces Africa",
        value: "AF"
    },
    {
        name: "Armed Forces America (exc. Canada)",
        value: "AA"
    },
    {
        name: "Armed Forces Canada",
        value: "AC"
    },
    {
        name: "Armed Forces Europe",
        value: "AE"
    },
    {
        name: "Armed Forces Middle East",
        value: "AM"
    },
    {
        name: "Armed Forces Pacific",
        value: "AP"
    }, 
];


/***/ }),

/***/ 26995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ usPostalCodeValidation; }
/* harmony export */ });
var usPostalCodeValidation = "^\\d{5}(-\\d{4})?$";


/***/ })

}]);